import * as common from './common.json';

export const de = {
  common,
};
